import React from "react";

// "" = todo el día; "HH:MM" = a una hora concreta.
export const horaAvisoLabel = (h) => (h ? `a las ${h}` : "todo el día");

export const HoraAviso = ({ value, onChange, testid }) => {
  const conHora = value !== "" && value != null;
  const pill = (activo) => `flex-1 min-h-[44px] rounded-xl font-semibold text-sm border transition-colors ${activo ? "bg-[#3A6B56] text-white border-[#3A6B56]" : "bg-white text-[#4A5550] border-[#E5DFD5]"}`;
  return (
    <div className="space-y-2" data-testid={testid}>
      <p className="text-sm font-semibold text-[#4A5550]">¿A qué hora?</p>
      <div className="flex gap-2">
        <button type="button" data-testid={`${testid}-todo-dia`} onClick={() => onChange("")} className={pill(!conHora)}>Todo el día</button>
        <button type="button" data-testid={`${testid}-con-hora`} onClick={() => !conHora && onChange("09:00")} className={pill(conHora)}>A una hora</button>
      </div>
      {conHora && (
        <input type="time" data-testid={`${testid}-hora`} value={value} onChange={(e) => onChange(e.target.value)}
          className="w-full min-h-[48px] px-3 rounded-xl bg-white border border-[#E5DFD5] text-base text-[#1C2421] focus:outline-none focus:ring-4 focus:ring-[#3A6B56]/20" />
      )}
      <p className="text-xs text-[#4A5550]">
        {conHora ? "El aviso llegará al móvil a esa hora." : "Te avisaremos al móvil la tarde anterior a las 18:00 y ese día a las 8:00."}
      </p>
    </div>
  );
};
